import React from "react";
import "./contactUs.css";

export default function ContactUs() {
  return (
    <section id="ContactUs" className="contactUs">
      <div className="contactContent">
        <div className="contactHead">
          <h1>
            Contact Us
            <img src="./images/Logos/Vector.png" alt="Vector"></img>
          </h1>
          <p>
            At Smith PVX Design Tool, we empower solar professionals with an all-in-one
            design tool that streamlines every step of the PV system workflow.
            From customer and site details to consumption profiling, roof
            design, and obstacle mapping, our platform integrates Google Maps
            for precise location selection and supports custom structures with
            detailed orientation settings. The tool seamlessly guides you
            through electrical configuration, financial analysis, and generates
            a comprehensive, customizable report with BOQ, shading analysis, and
            environmental benefits. With Smith PVX, designing smarter,
            efficient, and sustainable solar solutions has never been easier.
          </p>
        </div>
        <div className="contactInfo">
          <div className="contactInfoBox">
            <i className="bi bi-telephone-fill"></i>
            <div className="infoContent">
              <h6>+92 321 1119618</h6>
              <h6>+92 42 32390262</h6>
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-envelope-fill"></i>
            <div className="infoContent">
              <h6>info@bhgroup.com.pk</h6>
              {/* <h6>support@bhgroup.com.pk</h6> */}
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-geo-alt-fill"></i>
            <div className="infoContent">
              <h6>BH Group, 13-A, G-Block, MA Johar Town, Lahore</h6>
            </div>
          </div>
        </div>
        <div className="copyRights">
          <hr></hr>
          <h6>© Copyright 2024, All Rights Reserved by BH Smith</h6>
        </div>
      </div>
    </section>
  );
}
